export const localePlugin = {
  install: (app, { locale, localeUi }) => {
    app.provide('locale', locale);
    app.provide('localeUi', localeUi);
  },
};
